<div>
    <ngx-charts-line-chart
      [view]="charts.viewLineChartAdmin"
      [scheme]="charts.colorSchemeLineChart"
      [legend]="false"
      [legendPosition]="charts.legendPositionLineChartAdmin"
      [showXAxisLabel]="charts.showXAxisLabelLineChartAdmin"
      [showYAxisLabel]="charts.showYAxisLabelLineChartAdmin"
      [xAxis]="charts.showXAxisLineChartAdmin"
      [yAxis]="charts.showYAxisLineChartAdmin"
      [xAxisLabel]="charts.xAxisLabelBatLineChartAdmin"
      [yAxisLabel]="charts.yAxisLabelBatLineChartAdmin"
      [timeline]="true"
      [results]="charts.singleLineChartBat"
      (select)="charts.onSelectLineChart($event)"
      (activate)="charts.onActivateLineChart($event)"
      (deactivate)="charts.onDeactivateLineChart($event)"
      [xAxisTickFormatting]="charts.formatTimestamp"
      [yAxisTickFormatting]="charts.formatYAxisTickBat"
      [xAxisTickFormatting]="charts.formatTimestamp"
      [yAxisTickFormatting]="charts.formatYAxisTickBat"
      [yScaleMin]="charts.yScaleMinBat"
      [yScaleMax]="this.charts.yScaleMaxBat"
      >
     </ngx-charts-line-chart>
    <div class="line-chart-container">
      <h6>{{charts.xAxisLabelLineChartAdmin}}</h6>
      </div>
   </div> 
